import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class favoriteTask extends AbstractRequestTask {
  constructor(parameters, version = 'v1') {
    super();
    this.customParameters = parameters;
    this.version = version;
  }

  getHeaders() {
    return {};
  }

  getParams() {
    const params = super.getParams();
    delete params.api_version;
    delete params.HKS;
    delete this.customParameters.user_hash;
    return Object.assign({}, params, this.customParameters );
  }

  getUrl() {

    const protocol = 'https';
    const server = Launcher.get("akamai_mfwk");
    const endpoint = 'services/user';
    const version = this.version;
    const apiname = 'favoriteadd';
    
    return `${protocol}://${server}/${endpoint}/${version}/${apiname}`;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default favoriteTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/ficha/favoriteTask.js